import { Box, Heading, LinkButton, Spacer, Text } from '@homebotapp/hb-react-component-catalog'
import { ConfettiTarget } from '../../../shared/Confetti'
import { defineMessages, useIntl } from 'react-intl'
import { HomeownerDigestTrackingEventLocation } from '../../../../constants/tracking'
import { Link as ReactRouterLink } from 'react-router-dom'
import { OVERLAY_HELPERS } from '../../../../constants/navigation'
import { useDigestUrl } from '../../../../hooks/navigation'
import { selectHomeValue } from '../../../../store/selectors/home/metadata'
import { useAppSelector } from '../../../../store/hooks'
import { formatCurrency } from '../../../../helpers/formatters'
import { useAvmModuleContext } from '../../../shared/AvmModule/AvmModuleContext'
import { WizardValues } from '../HomePriceIndexWidgetWizard'

const MSG = defineMessages({
  heading: {
    id: 'HomePriceIndexWizard.steps.complete.heading',
    defaultMessage: 'Very Nice!'
  },
  subheading: {
    id: 'HomePriceIndexWizard.steps.complete.subheading',
    defaultMessage: 'Your estimated home value is now'
  },
  verifyMore: {
    id: 'HomePriceIndexWizard.steps.complete.verifyMore',
    defaultMessage: 'Verify more home details'
  },
  viewReport: {
    id: 'HomePriceIndexWizard.steps.complete.viewReport',
    defaultMessage: 'View your report'
  }
})

export const Complete = ({ values }) => {
  const intl = useIntl()
  const digestUrl = useDigestUrl()
  const homeValue = useAppSelector(selectHomeValue)

  const { baseValue } = values as WizardValues

  const tuneYourPath = baseValue
    ? { pathname: OVERLAY_HELPERS.tuneYourValue.buildPath(), search: 'requiredCma=1' }
    : OVERLAY_HELPERS.tuneYourValue.buildPath()

  return (
    <>
      {/* @ts-ignore */}
      <ConfettiTarget go numberOfPieces={150} />
      <Heading fontWeight='normal' mb='2'>
        {intl.formatMessage(MSG.heading)}
      </Heading>
      <Text>{intl.formatMessage(MSG.subheading)}</Text>
      <Box marginTop='2'>
        <Text size='2xl' color='brand'>
          {formatCurrency(homeValue)}
        </Text>
      </Box>
      <Spacer />
      <LinkButton
        as={ReactRouterLink}
        to={tuneYourPath}
        colorScheme='primary'
        width='100%'
        mb='2'
        tracking={{
          guid: 'j1C4zJgCQwkoncSnPhvo2k',
          descriptor: MSG.verifyMore.defaultMessage,
          ui_context: HomeownerDigestTrackingEventLocation.HOMEOWNER_DIGEST_HOME_PRICE_INDEX_WIZARD_COMPLETE_STEP
        }}
      >
        {intl.formatMessage(MSG.verifyMore)}
      </LinkButton>
      {/* Only show view report for people who have a home value and have NOT done a best guess - other TYV flow */}
      {homeValue !== 0 && !baseValue && (
        <LinkButton
          as={ReactRouterLink}
          to={digestUrl}
          tracking={{
            guid: 'kvsrhbBSaXeVvT7dCtRGFW',
            descriptor: MSG.viewReport.defaultMessage,
            ui_context: HomeownerDigestTrackingEventLocation.HOMEOWNER_DIGEST_HOME_PRICE_INDEX_WIZARD_COMPLETE_STEP
          }}
        >
          {intl.formatMessage(MSG.viewReport)}
        </LinkButton>
      )}
    </>
  )
}
